import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";

import {Range} from "@/modules/redactor/models/utils/Range";
import {ItemKindModel} from "@/modules/redactor/models/item/core/ItemKindModel";


export class ItemUpgradeRule extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemUpgradeRule, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemUpgradeRule, v);
            }
        );
    }

    constructor() {
        super();

        this._kind = null;
        this._level = new Range(0, 0);
        this._amount = 0;
    }

    get kind() {
        return this._kind;
    }

    set kind(value) {
        this._kind = value;
    }

    get level() {
        return this._level;
    }

    set level(value) {
        this._level = value;
    }

    get amount() {
        return this._amount;
    }

    set amount(value) {
        this._amount = value;
    }

    collide(rule) {
        return this.kind.equal(rule.kind) && this.level.collide(rule.level);
    }

    valid() {

        if (!ItemKindModel.is(this.kind)) {
            return false;
        }

        if (!this.level || !this.level.valid()) {
            return false;
        }

        if (!Number.isInteger(this.amount) || this.amount <= 0) {
            return false;
        }

        return true;
    }

    empty() {
        return !ItemKindModel.is(this.kind);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemUpgradeRule());
        } else if (target instanceof ItemUpgradeRule) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemUpgradeRule, {
    _kind: alias("kind", ItemKindModel.schema()),
    _level: alias("level", Range.schema()),
    _amount: alias("amount", Schema.primitive())
});